"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'message.send.failed': 'No se pudo enviar el mensaje',
};
